import { Point } from './location.model';
import { Taggable } from '@weavix/models/src/core/core';

export interface ItemType extends Taggable {
    id?: string;
    name: string;
    description?: string;
    mapItem: boolean;
    icon: {
        value: string;
        color: string;
    };
    fields: ItemField[];
    itemCount?: number;
    isDefault?: boolean;
}

export interface ItemTypeFacilities extends ItemType {
    facilityIds: string[];
}

export interface BaseItemField {
    fieldId?: string;
    display: string;
    type: FieldType;
}

export type TextField = BaseItemField;
export type NumberField = BaseItemField;

export interface DropDownField extends BaseItemField {
    options: string[];
}

export type ItemField = TextField | NumberField | DropDownField;

export enum FieldType {
    Dropdown = 'dropdown',
    Text = 'text',
    Number = 'number',
    Fixed = 'fixed',
    Date = 'date',
}
export interface FieldTransfer {
    fieldId?: string;
    display?: string;
    number?: number;
    editing?: boolean;
}

export interface ItemProperty {
    value: any;
    fieldId: string;
}

export interface Item extends Taggable {
    id?: string;
    name: string;
    typeId: string;
    location?: Point;
    itemProperties: ItemProperty[];
    locationAccuracy?: number;
    locationDate?: Date;
    owner?: string;
    rental?: boolean;
    assignedToId?: string; // person id
    image?: string;
    structureId?: string;
    level?: number;
}

export type AnyItem = Item;
